<div class="modal-backdrop" (click)="close.emit()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-head">
      <h5>History</h5>
      <button class="close-x" type="button" (click)="close.emit()" aria-label="Close">✕</button>
    </div>

    <div class="modal-body">
      <div class="cal-header">
        <button class="cal-nav" type="button" (click)="prevMonth()">‹</button>
        <span class="cal-month">{{ monthLabel }}</span>
        <button class="cal-nav" type="button" (click)="nextMonth()">›</button>
      </div>

      <div class="cal-grid">
        <div class="cal-dow" *ngFor="let dow of ['S','M','T','W','T','F','S']">{{ dow }}</div>
        <button *ngFor="let cell of monthCells"
                class="cal-cell"
                [class.out]="!cell.inMonth"
                [class.today]="cell.isToday"
                [class.partial]="cell.status === 'partial'"
                [class.full]="cell.status === 'full'"
                (click)="selectDate(cell.date)">
          <span class="cal-day">{{ cell.day }}</span>
          <span class="cal-dot" *ngIf="cell.status !== 'none'"></span>
        </button>
      </div>

      <div *ngIf="selectedDate" class="inspector">
        <div class="inspector-head">
          <strong>{{ selectedDate + 'T00:00:00' | date:'EEE MMM d, y' }}</strong>
          <button class="inspector-close" type="button" (click)="closeInspector()">Close</button>
        </div>

        <div class="inspector-habits">
          <div *ngFor="let h of habitsForSelectedDate" class="inspector-row">
            <button type="button"
                    class="inspector-toggle"
                    [class.done]="completionFor(h.id, selectedDate) !== null"
                    (click)="toggleDay(h)"
                    aria-label="Toggle">
              <span *ngIf="completionFor(h.id, selectedDate) !== null">✓</span>
            </button>
            <div class="inspector-info">
              <span class="inspector-name">{{ h.name }}</span>
              <span *ngIf="h.category" class="inspector-tag">{{ h.category }}</span>
              <span class="inspector-freq">{{ h.frequency }}</span>
            </div>
            <div class="inspector-note" *ngIf="completionFor(h.id, selectedDate)?.note">
              💬 {{ completionFor(h.id, selectedDate)?.note }}
            </div>
          </div>
        </div>

        <div class="inspector-journal">
          <h6>Journal</h6>
          <textarea
            placeholder="No journal for this day"
            [value]="journalFor(selectedDate)?.text || ''"
            (blur)="onInspectorJournalText($any($event.target).value)"
            rows="3"></textarea>
          <div class="inspector-ratings">
            <span class="rating-label">General</span>
            <span class="rating-stars">
              <button *ngFor="let i of [1,2,3,4,5]"
                      class="star-btn"
                      [class.filled]="(journalFor(selectedDate)?.generalRating || 0) >= i"
                      (click)="onInspectorGeneral(i)">★</button>
            </span>
            <span class="rating-label">Happiness</span>
            <span class="rating-emojis">
              <button *ngFor="let emoji of ['😢','😐','🙂','😀','😁']; let i = index"
                      class="emoji-btn"
                      [class.active]="(journalFor(selectedDate)?.happinessRating || 0) === i + 1"
                      (click)="onInspectorHappiness(i + 1)">{{ emoji }}</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
